import {$, empty, getParentElementByTagName, html_chargement_en_cours, initFullscreen} from "../../core/js/Dom.ts";
import {$get, $postForm} from "../../core/js/Ajax.ts";
import {initTooltips} from "../../core/js/Tooltip.ts";
import {animateLoadingButton, fadeOutFadeIn} from "../../core/js/Animate.ts";

export function initGlobalSearch() {
    const form = $('#search-global')
    form?.addEventListener('submit', handleSearchSubmit)
}

function handleSearchSubmit(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    const data = new FormData(event.target)
    const modalId = 'search-global-modal'
    const modale = $(`#${modalId}`)
    const modalBody = $(`#${modalId}-modal__content`)
    const frModal = window.dsfr(modale).modal

    if (modale && modalBody) {
        empty($('#block_tableaubord_liste'))
        empty(modalBody)
        modalBody.appendChild(html_chargement_en_cours())
        frModal.disclose()
        modale?.addEventListener('dsfr.conceal', () => {
            empty(modalBody)
            modalBody.appendChild(html_chargement_en_cours())
        })
        $get(event.target.action, {recherche: data.get('recherche')}).then((response) => {
            modalBody.innerHTML = response.body
            initTooltips(modale)
            initFullscreen($('#active-fullscreen'))
            ligneToDetail()
            $('#etendre-recherche-global', modalBody)?.addEventListener('click', etendreRecherche)
            if("#etendre-recherche-sujet-forum"){
                $('#etendre-recherche-sujet-forum', modalBody)?.addEventListener('click', etendreRechercheForum)
            }
        })
    }
}

function ligneToDetail() {
    const parentListeDossierInstruction = document.querySelector<HTMLElement>('.liste_dossier');
    if (parentListeDossierInstruction) {
        if (!parentListeDossierInstruction.classList.contains('event-attached')) {
            parentListeDossierInstruction.addEventListener('click', (e: Event) => {
                const target = e.target as HTMLElement;
                const clickedTr = target.closest('tr.clickligne');
                if (clickedTr && !target.classList.contains('select-checkbox')) {
                    const href = clickedTr.getAttribute('data-href');
                    const url = href ?? '';
                    window.open(url, '_blank')?.focus();
                }
            });
        }
        parentListeDossierInstruction.classList.add('event-attached');
    }
}

function etendreRecherche(event: DOMEvent<HTMLButtonElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    const url = target?.dataset.url
    const recherche = target?.dataset.recherche
    if(url && recherche) {
        animateLoadingButton(target, "Recherche...")
        const form = new FormData()
        form.append('recherche', recherche)
        form.append('type_page', "modal")
        $postForm(url, form).then((response) => {
            const content = $('#etendre-recherche-content')
            if (content) {
                content.innerHTML = response.body
                fadeOutFadeIn(target, content)
                if("#etendre-recherche-sujet-forum"){
                    $('#etendre-recherche-sujet-forum')?.addEventListener('click', etendreRechercheForum)
                }
            }
        })
    }
}

function etendreRechercheForum(event: DOMEvent<HTMLButtonElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    const url = target?.dataset.url
    if(url){
        animateLoadingButton(target, "Recherche...")
        $get(url).then((e) => {
            const content = $('#search-global-modal-modal__content')
            if (content) {
                content.innerHTML = e.body
                if($("#forum-pagination")){
                    const paginationLinks = document.querySelectorAll("#forum-pagination .fr-pagination__link")
                    paginationLinks.forEach(link => {
                        link.addEventListener('click', navigationForumModal)
                    })
                }
                // fadeOutFadeIn(target, content)
            }
        })
    }
}

function navigationForumModal(e) {
    e.preventDefault();

    // Traverse jusqu'à l'élément <a> au cas où e.target est un enfant (ex: un <span>)
    const link = e.target.closest('a');
    if (!link) return;

    const url = link.getAttribute('href');
    if (!url) return;

    fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => {
        if (!response.ok) throw new Error("Erreur lors du chargement des résultats");
        return response.text();
    })
    .then(html => {
        const content = $('#search-global-modal-modal__content');
        if (content) {
            content.innerHTML = html;

            // Re-attacher les handlers sur la nouvelle pagination (nécessaire à chaque rafraîchissement)
            const newLinks = document.querySelectorAll("#forum-pagination .fr-pagination__link");
            newLinks.forEach(link => {
                link.addEventListener('click', navigationForumModal);
            });
        }
    })
    .catch(error => {
        console.error("Erreur AJAX :", error);
    });
}